import {useEffect} from 'react'
import {css} from '@emotion/react'
import ReactDiffViewer from 'react-diff-viewer-continued'
import {MapContext} from '@/components/MindMap'
import ToolBar from './ToolBar.jsx'
import useMapData from './useMapData.mjs'

const cssMarkdownMap = css({
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    backgroundColor: '#fff',
    overflow: 'hidden',
})

const MarkdownMap = ({data, permission, ...props}) => {
    const map = useMap({data, permission})

    return (
        <div
            css={cssMarkdownMap}
            {...props}
        >
            <MapContext.Provider value={map}>
                <ToolBar />

                {
                    map.permission.has('write') ?
                        <MarkdownEditor
                            value={map.content}
                            onChange={value => map.setContent(value)}
                        />
                        :
                        <MarkdownViewer className="p-2">
                            {map.content}
                        </MarkdownViewer>
                }
            </MapContext.Provider>
        </div>
    )
}

export default function MarkdownMapWrapper({
    basDpId,
    basMapVerId,
    tarDpId,
    tarMapVerId,
    type,
    onLoad,
    ...props
}) {
    const data = useMapData({
        basDpId,
        basMapVerId,
        tarDpId,
        tarMapVerId,
        type,
    })

    useEffect(
        () => {
            if (data) {
                onLoad?.(data)
            }
        },

        [data]
    )

    if (! data) {
        return null
    }

    return (
        <ReactDiffViewer
            oldValue={data.left}
            newValue={data.right}
            splitView={true}
            {...props}
        />
    )
}
